// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__bkf-k","logo":"Auth_logo__d+cJ3","content":"Auth_content__JbfmG"};